<template>
    <div>
         <footer class="footer" id="footer">

        <div class="footer-container">

            <div class="footer-content">

                <div class="footer-image">

                    <div class="footer-image-container">
                        <div class="footer-image-content">
                           <h1>" Inspiration</h1>
                           <h1>come </h1>
                           <h1>from work "</h1>
                        </div>
                    </div>
                    
                </div>
                    <div class="midle">
                        <div class="midle-container">
                            <div class="midle-texte">
                                <h3 class="thanks">
                                    Thanks for visiting
                                </h3>
                            </div>
                            <div class="middle-star">
    
                                <div class="line-footer line-left">
            
                                </div>
                                <div class="middle-footer-start">
                                    <img src="@/assets/icons8-identité-médicale-50.png" alt="icon">
                                   
                                </div>
                                <div class="line-footer line-right">            
                                </div>
            
                        </div>
                        <div class="midle-texte">
                            <h3 class="thanks2">
                                Hope we can work together
                            </h3>
                        </div>
                        </div>
                    </div>
                <div class="form-container">
                    <div class="about-title">
                        <p>Contact Me</p>
                    </div>
                        <div>
                               
                                <div>
                                                <div class="alert">

                                                    <p class="message-sent">{{success}}</p>
                                                    <p class="message-not-sent">{{error}}</p>
                                                </div>
                                                <form class="input-form "  @submit.prevent="onSubmit">
                                                
                                                    <input class="input name" type="text" name="name" id="name" placeholder="name" v-model="name">
                                                    <input class="input email" type="email" name="email" id="email" placeholder="email" v-model="email">
                                                    <textarea class="input message" name="message" id="message" rows="5" placeholder="message" v-model="message"></textarea>
                                                    <button class="send-button" type="submit">send</button>
                                                </form>
                                </div>
                        </div>

                    <div class="contact">

                        <p>niyeraasaph@gmail.com</p>
                        <p>+821031711178</p>
                    </div>

                </div>

            </div>

        </div>


    </footer>
    </div>
</template>
<script>
import { initializeApp } from 'firebase/app';
import { getFirestore, collection,  writeBatch, FieldValue } from 'firebase/firestore'; 
import { getAuth, signInAnonymously } from 'firebase/auth'; 
export default {
    name: 'ContactComponent',
    data() {
        return {
            // this.db will now hold the Firestore instance
            db: null, 
            name: '',
            email: '',
            message: '',
            error: '',
            success: ''
        }
    },
    methods: {

        onSubmit() {
            // ... (Your validation logic is here)
             if (this.name && this.email && this.message) {
                 this.saveMessage(this.name, this.email, this.message);
                 this.name = '';
                 this.email = '';
                 this.message = '';
                 this.error = ''
                 this.success = 'Your message has been sent.'
             } else {
                 this.error = 'Please fill out all the fields.'
                 this.success = ''
             }
        },
        connectBackend(){
              var firebaseConfig = {
  apiKey: "AIzaSyAM5u4Aq6rqrX9ErX2t6oCgV8nBcxdDao8",
  authDomain: "portofoliodata.firebaseapp.com",
  databaseURL: "https://portofoliodata.firebaseio.com",
  projectId: "portofoliodata",
  storageBucket: "portofoliodata.firebasestorage.app",
  messagingSenderId: "949822654171",
  appId: "1:949822654171:web:7b5dba4b047191768b6efe",
  measurementId: "G-WN9R51P77R"
                                };
                                
                                // Initialize Firebase with modular functions
                                const app = initializeApp(firebaseConfig);
                this.db = getFirestore(app); // Get Firestore instance from the app
                        const auth = getAuth(app); 
          signInAnonymously(auth)
              .then(() => {
                  console.log("Signed in anonymously for rate limiting.");
              })
              .catch((error) => {
                  console.error("Anonymous sign-in failed:", error);
              });
        },
       saveMessage(name, email, message) {
         if (!getAuth().currentUser) {
             // Should not happen if connectBackend worked, but essential for safety
             console.error("User not authenticated for rate limit check.");
             return false;
         }

         const userId = getAuth().currentUser.uid;
         const batch = writeBatch(this.db); // Create a batch write

         // 1. Reference the new message document and the rate limit document
         const messagesCollectionRef = collection(this.db, "messages");
         const rateLimitDocRef = this.db.collection("rateLimits").doc(userId); // Reference for the rate limit doc

         // 2. Add the message document to the batch
         batch.set(messagesCollectionRef.doc(), {
             name: name,
             email: email,
             message: message
         });

         // 3. Update the rate limit document (This must be done in the same batch)
         // Use FieldValue.serverTimestamp() to ensure the rule uses the server time
         batch.set(rateLimitDocRef, { 
             lastWrite: FieldValue.serverTimestamp() 
         }, { merge: true }); // Use merge: true for existing documents

         // 4. Commit the batch write
    return batch.commit().then(() => {
    // SUCCESS: Clear form, show success message
}).catch((error) => {
    // FAILURE: Check the error code here
    if (error.code === 'permission-denied') { 
        // Display a specific message to the user:
        // "Please wait 5 minutes before sending another message."
        this.error = "You are sending messages too quickly. Please wait a moment.";
    } else {
        // Handle other errors
        console.error("Error sending message:", error);
    }
});
     },
    },
    created() {
         this.connectBackend();
    },
}
</script>
<style lang="css">
    
</style>